/** @jsxImportSource hono/jsx/dom */
import type { FC } from 'hono/jsx'
import { useCallback, useRef, useState } from 'hono/jsx'
import { ApiError, searchWords, wordPath } from './api'
import { navigate } from './router'

export const SearchWidget: FC = () => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [results, setResults] = useState<string[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const onSubmit = useCallback(async (event: Event) => {
    event.preventDefault()
    const q = inputRef.current?.value ?? ''
    if (q.trim() === '') return
    setBusy(true)
    setError(null)
    try {
      setResults(await searchWords(q))
    } catch (err) {
      setResults(null)
      setError(err instanceof ApiError ? err.message : '検索に失敗しました')
    } finally {
      setBusy(false)
    }
  }, [])

  const onSelect = useCallback((event: Event, word: string) => {
    const mouse = event as MouseEvent
    // 修飾キー付きのクリックはブラウザの既定動作に任せる
    if (mouse.metaKey || mouse.ctrlKey || mouse.shiftKey || mouse.altKey) return
    event.preventDefault()
    navigate(word)
  }, [])

  return (
    <div>
      <form class="stack" onSubmit={onSubmit}>
        <label class="field">
          <span class="field-label">単語</span>
          <input
            ref={inputRef}
            type="search"
            name="q"
            required
            maxlength={100}
            autocomplete="off"
            placeholder="git"
          />
        </label>
        <button type="submit" disabled={busy}>
          {busy ? '検索中…' : '検索'}
        </button>
      </form>

      {error ? (
        <p class="error-text" role="status">
          {error}
        </p>
      ) : null}

      {results !== null && !error ? (
        results.length === 0 ? (
          <p class="empty">見つかりませんでした</p>
        ) : (
          <ul class="search-results">
            {results.map((word) => (
              <li key={word}>
                <a href={wordPath(word)} onClick={(event: Event) => onSelect(event, word)}>
                  {word}
                </a>
              </li>
            ))}
          </ul>
        )
      ) : null}
    </div>
  )
}
